var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('side-card', {
    attrs: {
      "title": _vm.$t('components.FilterCardPagination.title'),
      "absolute": true,
      "loading": false,
      "width": !_vm.$vuetify.breakpoint.smAndDown ? '600px' : '100%',
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    on: {
      "close": _vm.onRequestClose
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('div', {
    staticClass: "v-item-group theme--light v-expansion-panels v-expansion-panels--accordion v-expansion-panels--flat  pa-0"
  }, [_c('div', {
    staticClass: "v-expansion-panel ma-0 pa-0"
  }, [_vm.predefinedFilter && _vm.predefinedFilter.length ? _c('div', [_c('div', {
    staticClass: "v-expansion-panel-header pa-0 text-subtitle-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.suggestions")) + " "), _c('span', {
    staticClass: "ml-1"
  }, [_c('a-eicon', {
    attrs: {
      "noColor": true
    }
  })], 1)]), _c('div', {
    staticClass: "v-expansion-panel-content pa-0"
  }, [_c('div', {
    staticClass: "v-expansion-panel-content pa-0"
  }, [_c('div', {
    staticClass: "v-expansion-panel-content__wrap pa-0"
  }, _vm._l(_vm.predefinedAndQuickFilters, function (item, index) {
    return _c('v-chip', {
      key: 'applied-filter-' + index,
      staticClass: "mr-1 mt-1",
      attrs: {
        "color": _vm.isPredefinedFilterActive(item.name, item.isQuick) ? 'primary' : '',
        "label": "",
        "close": _vm.isPredefinedFilterActive(item.name, item.isQuick)
      },
      on: {
        "click": function click($event) {
          return _vm.setPreselectedFilter(item.name, item.isQuick);
        },
        "click:close": function clickClose($event) {
          return _vm.removePreselectedFilter(item.name, item.isQuick);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)])])]) : _vm._e(), _c('div', {
    staticClass: "v-expansion-panel-header pa-0 text-subtitle-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.activeFilters")) + " ")]), _c('div', {
    staticClass: "v-expansion-panel-content pa-0"
  }, [_c('div', {
    staticClass: "v-expansion-panel-content__wrap pa-0"
  }, [_vm._l(_vm.activeFiltersFromCompleteFilterListUniqueIds, function (item, index) {
    return _c('v-chip', {
      key: 'applied-filter-' + index + item,
      staticClass: "ma-1",
      attrs: {
        "label": "",
        "color": "info",
        "close": ""
      },
      on: {
        "click": function click($event) {
          return _vm.openFilterPanel(item);
        },
        "click:close": function clickClose($event) {
          return _vm.clearItemValueById(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getDisplayName(item)) + " ")]);
  }), !_vm.activeFiltersFromCompleteFilterList.length ? _c('div', {
    staticClass: "mt-2 mb-1"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t("components.FilterCardPagination.noFilter")))])]) : _vm._e()], 2)])])]), _c('v-divider', {
    staticClass: "mt-3"
  }), _c('v-expansion-panels', {
    staticClass: "pa-0",
    attrs: {
      "multiple": "",
      "accordion": "",
      "flat": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, _vm._l(_vm.groupedFiltersList, function (item, i) {
    return _c('v-expansion-panel', {
      key: "v-expansion-panel-filter-card-pagination-option-".concat(i),
      staticClass: "ma-0 pa-0",
      attrs: {
        "id": _vm.getPanelId(item.filterOption.id)
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "pa-0",
      on: {
        "click": function click($event) {
          return _vm.onenFilterPanel(i);
        }
      }
    }, [_vm._v(" " + _vm._s(item.filterOption.displayName ? _vm.$t(item.filterOption.displayName) : item.filterOption.key) + " "), _c('debug', _vm._l(item.filter, function (filter, index) {
      return _c('span', {
        key: 'filter-' + index + filter.key
      }, [filter.value !== '' ? _c('v-chip', {
        staticClass: "mr-1",
        attrs: {
          "small": "",
          "close": "",
          "label": ""
        },
        on: {
          "click:close": function clickClose($event) {
            return _vm.removeFilter(item, index);
          }
        }
      }, [_vm._v(" " + _vm._s(_vm.$t("components.filter.".concat(filter.operation))) + " " + _vm._s(filter.value) + " ")]) : _vm._e()], 1);
    }), 0)], 1), _c('v-expansion-panel-content', {
      staticClass: "pa-0"
    }, [_c('filter-card-pagination-side-card-filter-element', {
      staticClass: "mt-1",
      attrs: {
        "value": item
      }
    })], 1), i < _vm.groupedFiltersList.length - 1 ? _c('v-divider') : _vm._e()], 1);
  }), 1)], 1), _c('div', {
    staticClass: "footer"
  }, [_c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": _vm.removeAllAndClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.FilterCardPagination.removeAll")) + " ")]), _c('v-btn', {
    attrs: {
      "small": "",
      "elevation": "0",
      "color": "info",
      "data-test-filter-apply": ""
    },
    on: {
      "click": _vm.confirmFilterAndClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")])], 1)], 1)]), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.showConfirmDialog,
      "max-width": "400",
      "title": _vm.$t('components.FilterCardPagination.confirmDialogTitle'),
      "subtitle": _vm.$t('components.FilterCardPagination.confirmDialogSubtitle'),
      "confirm-label": _vm.$t('apply'),
      "cancel-label": _vm.$t('close')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.showConfirmDialog = $event;
      },
      "rightClick": _vm.onDialogConfirm,
      "leftClick": _vm.onDialogClose,
      "close": function close($event) {
        _vm.showConfirmDialog = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }